import Vue from 'vue';
import Vuex from 'vuex';
import axios from '@/app-axios';

// Module imports
import { alert } from './modules/alert.module';
import { decision } from './modules/decision.module';
import { swiftuser } from './modules/swiftuser.module';
import { questions } from './modules/questions.module';
import { register } from './modules/register.module';
import { userprofile } from './modules/userprofile.module';
import { passcodereset } from './modules/passcodereset.module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
  },
  mutations: {
    setUserData (state, userData) {
      state.user = userData;
      localStorage.setItem('user', JSON.stringify(userData));
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
    },

    clearUserData () {
      localStorage.removeItem('user');
      localStorage.removeItem('checkInTime');
      localStorage.removeItem('checkIn');
    },
  },
  actions: {
    login ({ commit }, credentials) {
      return axios
        .post('api/devices/login', credentials)
        .then(({ data }) => {
          commit('setUserData', data);
        });
    },

    logout ({ commit }) {
      commit('clearUserData');
    },
  },

  getters: {
    isLogged: state => !!state.user,
    getUser (state) {
      return state.user;
    },
  },

  modules: {
    alert,
    decision,
    questions,
    swiftuser,
    register,
    userprofile,
    passcodereset,
  },
});
